// extracted by mini-css-extract-plugin
export default {"container":"Burger_container__IfgYt","opened":"Burger_opened__kioL3"};